module.exports = __webpack_public_path__ + "img/privilege2.5d270f82.png";